import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=2fcb68f1&scoped=true"
import script from "./ContractEditor.vue?vue&type=script&lang=js"
export * from "./ContractEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb68f1",
  null
  
)

export default component.exports